var map = {
	"./404.vue": 3516,
	"./Home.vue": 4399,
	"./about.vue": 3619,
	"./amc.vue": 2773,
	"./become-sub-broker.vue": 8194,
	"./brokerage-charges.vue": 9790,
	"./calculator/brokerage-calculator.vue": 6183,
	"./calculator/compound-interest.vue": 2160,
	"./calculator/elss.vue": 1449,
	"./calculator/emi-calculator.vue": 2299,
	"./calculator/future-value.vue": 5633,
	"./calculator/gratuity.vue": 5650,
	"./calculator/gst.vue": 1709,
	"./calculator/hra-house-rent-allowance-calculator.vue": 68,
	"./calculator/index.vue": 5450,
	"./calculator/lumpsum-calculator.vue": 3463,
	"./calculator/mutual-fund-return.vue": 6062,
	"./calculator/nps.vue": 9872,
	"./calculator/npv.vue": 3131,
	"./calculator/option-value.vue": 1796,
	"./calculator/ppf-public-provident-fund.vue": 2751,
	"./calculator/simple-interest.vue": 6720,
	"./calculator/sip-calculator.vue": 3612,
	"./calculator/span-calculator.vue": 47,
	"./calculator/swp.vue": 4426,
	"./calculator/trade-price-checker.vue": 8850,
	"./contact-us.vue": 214,
	"./contact-us/raise-a-ticket.vue": 3329,
	"./free-chart-view-for-live-trading.vue": 1416,
	"./glossary-page.vue": 9382,
	"./glossary.vue": 4910,
	"./glossary/52-week-high.vue": 2680,
	"./glossary/52-week-low.vue": 5399,
	"./glossary/abc-wave-theory.vue": 2151,
	"./glossary/abridged-prospectus.vue": 8818,
	"./glossary/acceptance-credit.vue": 8130,
	"./glossary/accrued-expenses.vue": 2660,
	"./glossary/accrued-interest.vue": 2046,
	"./glossary/accumulation-distribution-line-adl.vue": 5626,
	"./gold-rates.vue": 1331,
	"./income-tax-calculator.vue": 2332,
	"./invest-in-share-market.vue": 7104,
	"./ipo.vue": 1941,
	"./ipo/sme.vue": 9774,
	"./learning-center/art-page.vue": 9560,
	"./learning-center/demat-account.vue": 3946,
	"./learning-center/demat-account/best-demat-account-for-beginners-in-india.vue": 3591,
	"./learning-center/demat-account/can-a-demat-account-be-opened-without-a-pan-card.vue": 2765,
	"./learning-center/demat-account/demat-account-opening-procedur.vue": 4154,
	"./learning-center/demat-account/how-to-buy-sell-shares-in-demat-account.vue": 7964,
	"./learning-center/demat-account/how-to-download-demat-holdings-statement.vue": 2647,
	"./learning-center/demat-account/is-demat-account-safe.vue": 2811,
	"./learning-center/demat-account/what-is-a-brokerage-account.vue": 7006,
	"./learning-center/demat-account/what-is-ledger-balance-in-demat-account.vue": 7810,
	"./learning-center/demat-account/what-is-the-minimum-amount-required-for-opening-a-demat-account.vue": 9831,
	"./learning-center/exploremore-lc-cat.vue": 4731,
	"./learning-center/futures-and-options.vue": 7760,
	"./learning-center/futures-and-options/best-ways-to-calculate-commodity-price-risks-understanding-the-main-risks-involved.vue": 8450,
	"./learning-center/futures-and-options/commodities-speculators-more-rewards-than-risks.vue": 8464,
	"./learning-center/futures-and-options/how-to-calculate-fo-turnover.vue": 694,
	"./learning-center/futures-and-options/how-to-trade-in-options-with-small-capital-strategies-for-success.vue": 6189,
	"./learning-center/futures-and-options/navigating-tradable-commodities-basics-and-beyond.vue": 3124,
	"./learning-center/futures-and-options/top-3-commodities-mutual-funds-for-a-diversified-investment-portfolio.vue": 3390,
	"./learning-center/futures-and-options/top-5-futures-trading-strategies-to-know-in-2023-2024.vue": 8676,
	"./learning-center/futures-and-options/understanding-soft-commodity-key-differentiators-between-soft-hard-commodities.vue": 992,
	"./learning-center/futures-and-options/understanding-spot-commodities-key-features-and-functions.vue": 8038,
	"./learning-center/intraday-trading.vue": 304,
	"./learning-center/intraday-trading/basics-of-investing-in-intraday-trading.vue": 6083,
	"./learning-center/intraday-trading/difference-between-intraday-and-delivery-trading.vue": 7352,
	"./learning-center/intraday-trading/how-are-gains-from-intraday-trading-taxed-for-itr.vue": 2416,
	"./learning-center/intraday-trading/how-to-do-intraday-trading.vue": 2893,
	"./learning-center/intraday-trading/intraday-trading-tips-and-tricks.vue": 3304,
	"./learning-center/intraday-trading/risk-management-in-intraday-trading.vue": 3627,
	"./learning-center/intraday-trading/what-is-a-cover-order.vue": 229,
	"./learning-center/intraday-trading/what-is-day-trading.vue": 1729,
	"./learning-center/intraday-trading/what-is-intraday-trading.vue": 2138,
	"./learning-center/ipo.vue": 8556,
	"./learning-center/ipo/list-of-upcoming-ipos-in-india-new-ipo-launch.vue": 2628,
	"./learning-center/ipo/qualified-institutional-buyers-qibs-in-ipo-in-india-definition.vue": 7858,
	"./learning-center/ipo/venture-capital-backed-ipo-definition-example-explained.vue": 4826,
	"./learning-center/ipo/what-is-a-secondary-offering-ipo-meaning-types.vue": 9241,
	"./learning-center/ipo/what-is-difference-between-ipo-and-fpo-in-share-market.vue": 3462,
	"./learning-center/ipo/what-is-hot-ipo-and-how-does-it-work-meaning-and-examples.vue": 9398,
	"./learning-center/ipo/what-is-ipo-grading-process-in-india-meaning.vue": 4427,
	"./learning-center/ipo/what-is-roadshow-in-ipo.vue": 3258,
	"./learning-center/ipo/what-is-the-difference-between-equity-ipo-vs-debt-ipo.vue": 1895,
	"./learning-center/mutual-funds.vue": 1170,
	"./learning-center/mutual-funds/elss-vs-sip-difference-and-which-is-better.vue": 8408,
	"./learning-center/mutual-funds/finding-the-best-mutual-funds-for-investing-inr-1-lakh.vue": 6800,
	"./learning-center/mutual-funds/generating-income-by-investing-in-mutual-funds.vue": 5014,
	"./learning-center/mutual-funds/how-capital-infusion-affects-mutual-funds.vue": 9824,
	"./learning-center/mutual-funds/how-indexation-helps-save-taxes-on-capital-gains-from-mutual-funds.vue": 5512,
	"./learning-center/mutual-funds/how-to-choose-the-best-focused-funds.vue": 9424,
	"./learning-center/mutual-funds/liquid-funds-vs-fixed-deposits-difference-which-is-better.vue": 8442,
	"./learning-center/mutual-funds/tips-for-investing-in-mutual-funds-and-how-to-start-investing.vue": 1937,
	"./learning-center/mutual-funds/understanding-mutual-fund-ratios-a-comprehensive-guide-for-investors.vue": 2256,
	"./learning-center/online-trading.vue": 5904,
	"./learning-center/online-trading/algo-trading-in-india-strategies-meaning-tips.vue": 3712,
	"./learning-center/online-trading/basic-key-ideas-for-stock-traders-and-investors.vue": 839,
	"./learning-center/online-trading/gravestone-doji-how-to-trade-candlestick-pattern-meaning.vue": 5539,
	"./learning-center/online-trading/key-characteristics-of-a-good-investment-strategy.vue": 2441,
	"./learning-center/online-trading/mastering-stock-market-trends-proven-techniques-for-successful-trading.vue": 9299,
	"./learning-center/online-trading/stock-market-basics-for-beginners-a-guide-to-investing-and-trading.vue": 6375,
	"./learning-center/online-trading/support-and-resistance-indicator-a-beginners-guide-to-smarter-trading.vue": 114,
	"./learning-center/online-trading/understanding-how-to-interpret-a-balance-sheet-effectively.vue": 9836,
	"./learning-center/online-trading/what-is-a-physical-settlement.vue": 787,
	"./learning-center/share-market.vue": 7039,
	"./learning-center/share-market/15-basic-stock-market-terms-every-new-investor-or-trader-must-know.vue": 8535,
	"./learning-center/share-market/5-no-balls-in-the-stock-market-you-shouldnt-bowl.vue": 1175,
	"./learning-center/share-market/5-undervalued-stocks-to-buy-under-rs-50.vue": 6442,
	"./learning-center/share-market/everything-you-need-to-know-about-the-15-15-15-rule-in-mutual-funds.vue": 9307,
	"./learning-center/share-market/list-of-50-stocks-under-asm.vue": 3412,
	"./learning-center/share-market/market-watch-mutual-funds-top-buys-and-sells.vue": 9554,
	"./learning-center/share-market/the-5g-revolution-the-best-5g-stocks-to-invest-in-india.vue": 141,
	"./learning-center/share-market/top-10-solar-energy-stocks-in-india-investing-in-sustainability.vue": 3269,
	"./learning-center/share-market/top-5-small-finance-bank-stocks-in-india.vue": 1355,
	"./learning-center/trading-account.vue": 2293,
	"./learning-center/trading-account/buy-today-and-sell-tomorrow-btst-trading-strategy.vue": 1777,
	"./learning-center/trading-account/how-to-open-a-commodity-trading-account.vue": 1868,
	"./learning-center/trading-account/how-to-open-trading-account-online.vue": 7918,
	"./learning-center/trading-account/insider-trading-legal-or-illegal-in-india.vue": 14,
	"./learning-center/trading-account/trading-account-is-which-type-of-account.vue": 7513,
	"./learning-center/trading-account/what-is-commodity-market.vue": 9441,
	"./learning-center/trading-account/what-is-commodity-trading-overview-benefits-of-investing.vue": 6045,
	"./learning-center/trading-account/what-is-gross-profit-how-to-calculate-gross-profit.vue": 9420,
	"./learning-center/trading-account/what-is-swing-trading.vue": 9279,
	"./life-at-upstox.vue": 6785,
	"./market-talk.vue": 4914,
	"./market-talk/january-updates-trade-from-charts-watchlist-tags-and-more.vue": 2387,
	"./market-talk/tools-to-power-your-trades-and-investments-december-2024.vue": 5125,
	"./market-talk/tools-to-power-your-trades-and-investments-february-2025.vue": 4502,
	"./market-talk/tools-to-power-your-trades-and-investments-july-2024.vue": 7545,
	"./market-talk/tools-to-power-your-trades-and-investments-november-2024.vue": 7315,
	"./market-talk/tools-to-power-your-trades-and-investments-october-2024.vue": 8340,
	"./mutual-funds.vue": 154,
	"./news.vue": 60,
	"./stocks-market/bse-holidays.vue": 6512,
	"./stocks-market/mcx-holidays.vue": 8508,
	"./stocks-market/nse-bse-share-market-timing-in-india.vue": 5788,
	"./stocks-market/nse-holidays.vue": 8362,
	"./stocks-market/share-market-holidays.vue": 6641,
	"./stocks/indian-railway-fin-corp-l-share-price/INE053F01010.vue": 3820,
	"./stocks/stocks-under-50.vue": 8659,
	"./terms-of-use-and-privacy-policy.vue": 6301,
	"./tick-by-tick-trading.vue": 8953,
	"./trade-in-futures-and-options.vue": 1485,
	"./trade-on-charts.vue": 7107,
	"./uplearn.vue": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9464;